export default "__VITE_ASSET__DxkmF0GB__"